import { SPage } from 'servisofts-component2';
import login from "./login";
import root from "./root";
export default SPage.combinePages("admin", {
    "": root,
    login: login,
    
});